module.exports = __webpack_public_path__ + "assets/veteran-040dd3485f1a6d6330fbc37d5e0261ff.svg";